<form [formGroup]= "formUser" (ngSubmit)= "onSubmit()">
    <mat-card>
        <h4>{{'REGISTER.PROFILE' | translate}}:</h4>
        <div class="pt-3">
      
        <mat-form-field class="w-100">
            <mat-label>{{'REGISTER.FIRST_NAME' | translate}}</mat-label>
            <input matInput type="text" formControlName="name" [value]="user?.name" required/>
        </mat-form-field> 

        <mat-form-field class="w-100">
            <mat-label>{{'REGISTER.LAST_NAME' | translate}}</mat-label>
            <input matInput type="text" formControlName="surname" [value]="user?.surname" required/>
        </mat-form-field> 

        <mat-form-field class="w-100">
            <mat-label>{{'REGISTER.EMAIL' | translate}}</mat-label>
            <input matInput type="text" formControlName="email" [value]="user?.email" required/>
        </mat-form-field> 

        <mat-form-field class="w-100">
            <mat-label>{{'REGISTER.USERNAME' | translate}}</mat-label>
            <input matInput type="text" formControlName="username" [value]="user?.username" required/>
        </mat-form-field> 

        <mat-form-field class="w-100">
            <mat-label>{{'REGISTER.MOBILE_NUMBER' | translate}}</mat-label>
            <input matInput type="text" formControlName="phoneNumber" [value]="user?.phoneNumber" required/>
        </mat-form-field> 
        <button mat-raised-button type="submit" color="accent"  >
              {{ 'REGISTER.CONFIRM_CHANGES' | translate }}
        </button>
        <h5 *ngIf="error" style="color: red;">{{ 'REGISTER.ERROR_UPDATE_PROFILE' | translate }}</h5>
        </div>
    </mat-card>
</form>